import React from "react";
import { Col, ListGroup, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IOrder } from "common/types";
import Spinner from "../../spinner";

interface StudentOrderListProps {
  unpaidOrders: IOrder[];
  loading: boolean;
}

function StudentOrderList({ unpaidOrders, loading }: StudentOrderListProps) {
  if (loading) {
    return <Spinner />;
  }

  if (unpaidOrders.length === 0) {
    return <></>;
  }

  return (
    <Row className="mt-4">
      <Col lg={6}>
        <h4 className="mb-4">Pripreme koje je potrebno platiti</h4>
        <ListGroup variant="flush">
          {unpaidOrders.map((order: IOrder) => (
            <ListGroup.Item
              key={order.id}
              className="active-order-card d-flex align-items-center justify-content-between"
            >
              <div>
                <div>{order.course.title}</div>
                <div>{order.amount} EUR</div>
              </div>
              <Link to={`/narudzba/${order.id}`}>
                <Button variant="primary">Plati</Button>
              </Link>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Col>
    </Row>
  );
}

export default StudentOrderList;
